import React from 'react'
import { ComingSoon } from '@/components/common/ComingSoon'

const BillsPage = () => {
  return (
    <ComingSoon 
      title="AP Bills"
      description="Manage vendor bills and payments"
    />
  )
}

export default BillsPage
